// extracted by mini-css-extract-plugin
export var Nav = "Nav-module--Nav--16756";
export var NavItem = "Nav-module--NavItem--5b398";
export var NavItemScaleDown = "Nav-module--NavItemScaleDown--4a57c";
export var NavList = "Nav-module--NavList--f8cb5";
export var bottom = "Nav-module--bottom--9b217";
export var grit = "Nav-module--grit--eccbf";
export var top = "Nav-module--top--2af3e";